import { forwardRef, type Ref, type SVGProps } from "react";
const IconTextAlignCenterOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M3 5h26a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2m3.79 6a1 1 0 1 0 0 2h18.42a1 1 0 0 0 0-2ZM29 19H3a1 1 0 0 0 0 2h26a1 1 0 0 0 0-2m-7 8H10a1 1 0 0 0 0 2h12a1 1 0 0 0 0-2" />
  </svg>
);
const ForwardRef = forwardRef(IconTextAlignCenterOutlineSVG);
ForwardRef.displayName = "IconTextAlignCenterOutline";
export { ForwardRef as IconTextAlignCenterOutline };
